// extracted by mini-css-extract-plugin
module.exports = {"summaryLengthButtons":"styles-module__summaryLengthButtons___3jb1h","active":"styles-module__active___21I6v"};